import React from 'react'
import atoms from '../../atoms'
import { checkPermissionsInArray, priceTagFormatter } from '../../../constants/utils'
import { useNavigate } from 'react-router'
import { AllPermissions } from '../../../constants/permission'
const { Button } = atoms
const Index = ({ dashboardDetails }: any) => {
  const navigate = useNavigate()

  return (
    <div className="">
      <div className="row">
        <div className='col-lg-8 row'>
       {checkPermissionsInArray(AllPermissions.STORE_INVENTORY_BIRD_EYE_VIEW_TAB) && <div className="col-md-6">
          <div className="card-dashboard mx-auto cursor-pointer card-dashboard-width"
            onClick={() => navigate('/inventory/detail')}>
            <div className="card-body">
              <div className='fs-md-24 fs-20 fw-600'>Inventory</div>
              <div className="d-flex justify-content-between mt-md-3 mt-1">
                <div>
                  <p className="card-text fs-md-16 fs-14 fw-400 ">Total Branch Inventory</p>
                  <p className="card-title fs-md-14 fs-12 fw-600 ">{dashboardDetails.store_inventory_count} | {priceTagFormatter(dashboardDetails.store_inventory_landing_cost)} </p>
                  <p className="text-muted fs-10 fw-500 mb-2"> Quantity | Amount (L. Cost) </p>
                </div>
                <div className="icon-container ">
                  <i className="fas fa-shopping-cart"></i>
                </div>
              </div>
              <hr className='line-margin'></hr>
              <div>
                <p className="card-text fs-md-16 fs-14 fw-400 ">Total Salable Inventory</p>
                <p className="card-title fs-md-14 fs-12 fw-600 ">{dashboardDetails.saleable_inventory_count} | {priceTagFormatter(dashboardDetails.saleable_inventory_landing_cost)} </p>
                <p className="text-muted fs-10 fw-500"> Quantity | Amount (L. Cost) </p>
              </div>
            </div>
          </div>
        </div>}

        {checkPermissionsInArray(AllPermissions.STORE_SALES_ORDER_BIRD_EYE_VIEW_TAB) && <div className="col-md-6">
          <div className="card-dashboard mx-auto cursor-pointer card-dashboard-width"
            onClick={() => navigate('/order/detail')}>
            <div className="card-body">
              <div className='fs-md-24 fs-20 fw-600'>Sales Order</div>
              <div className="d-flex justify-content-between mt-md-3 mt-1">
                <div>
                  <p className="card-text fs-md-16 fs-14 fw-400 ">Today</p>
                  <p className="card-title fs-md-14 fs-12 fw-600 mb-md-1">{dashboardDetails.current_day_orders}/ {priceTagFormatter(dashboardDetails.current_day_orders_value)} </p>
                </div>
                <div className="icon-container ">
                  <i className="fas fa-shopping-cart"></i>
                </div>
              </div>
              <hr className='line-margin'></hr>
              <div>
                <p className="card-text fs-md-16 fs-14 fw-400 ">This Month</p>
                <p className="card-title fs-md-14 fs-12 fw-600 mb-2">{dashboardDetails.current_month_orders} / {priceTagFormatter(dashboardDetails.current_month_orders_value)}</p>
              </div>
              <hr className='line-margin'></hr>
              <div>
                <p className="card-text fs-md-16 fs-14 fw-400 ">This year</p>
                <p className="card-title fs-md-14 fs-12 fw-600 ">{dashboardDetails.current_financial_year_orders} / {priceTagFormatter(dashboardDetails.current_financial_year_orders_value)}</p>
              </div>
            </div>
          </div>
        </div>}

        </div>

        {checkPermissionsInArray(AllPermissions.STORE_RECEIPTS_BIRD_EYE_VIEW_TAB) && <div className="col-lg-4 d-none d-lg-block">
          <div className="card-dashboard mx-auto card-dashboard-width">
            <div className="card-body">
              <div className='fs-md-24 fs-20 fw-600'>Receipts</div>
              <div className="d-flex justify-content-between mt-md-3 mt-1">
                <div>
                  <p className="card-text fs-md-16 fs-14 fw-400 ">Today</p>
                  <p className="card-title fs-md-14 fs-12 fw-600 ">  {priceTagFormatter(dashboardDetails.current_day_cash)} / {priceTagFormatter(dashboardDetails.current_day_card)} / {priceTagFormatter(dashboardDetails.current_day_upi)} </p>
                  <p className="text-muted fs-10 fw-500 mb-2"> Cash | Card | UPI </p>
                </div>
                <div className="icon-container ">
                  <i className="fas fa-shopping-cart"></i>
                </div>
              </div>
              <hr className='line-margin'></hr>
              <div>
                <p className="card-text fs-md-16 fs-14 fw-400 ">This Month</p>
                <p className="card-title fs-md-14 fs-12 fw-600 "> {priceTagFormatter(dashboardDetails.current_month_cash)} / {priceTagFormatter(dashboardDetails.current_month_card)} / {priceTagFormatter(dashboardDetails.current_month_upi)}</p>
                <p className="text-muted fs-10 fw-500 mb-2"> Cash | Card | UPI </p>
              </div>
              <hr className='line-margin'></hr>
              <div>
                <p className="card-text fs-md-16 fs-14 fw-400 ">This year</p>
                <p className="card-title fs-md-14 fs-12 fw-600 "> {priceTagFormatter(dashboardDetails.current_year_cash)} / {priceTagFormatter(dashboardDetails.current_year_card)} / {priceTagFormatter(dashboardDetails.current_year_upi)}</p>
                <p className="text-muted fs-10 fw-500"> Cash | Card | UPI </p>
              </div>
            </div>
          </div>
        </div>}
      </div>

    {checkPermissionsInArray(AllPermissions.STORE_RECEIPTS_BIRD_EYE_VIEW_TAB) &&  <div className="row">
      <div className="col-md-6 col-lg-4 d-lg-none">
          <div className="card-dashboard mx-auto card-dashboard-width">
            <div className="card-body">
              <div className='fs-md-24 fs-20 fw-600'>Receipts</div>
              <div className="d-flex justify-content-between mt-md-3 mt-1">
                <div>
                  <p className="card-text fs-md-16 fs-14 fw-400 ">Today</p>
                  <p className="card-title fs-md-14 fs-12 fw-600 "> {priceTagFormatter(dashboardDetails.current_day_cash)} / {priceTagFormatter(dashboardDetails.current_day_card)} / {priceTagFormatter(dashboardDetails.current_day_upi)} </p>
                  <p className="text-muted fs-10 fw-500 mb-2"> Cash | Card | UPI </p>
                </div>
                <div className="icon-container ">
                  <i className="fas fa-shopping-cart"></i>
                </div>
              </div>
              <hr className='line-margin'></hr>
              <div>
                <p className="card-text fs-md-16 fs-14 fw-400 ">This Month</p>
                <p className="card-title fs-md-14 fs-12 fw-600 "> {priceTagFormatter(dashboardDetails.current_month_cash)} / {priceTagFormatter(dashboardDetails.current_month_card)} / {priceTagFormatter(dashboardDetails.current_month_upi)}</p>
                <p className="text-muted fs-10 fw-500 mb-2"> Cash | Card | UPI </p>
              </div>
              <hr className='line-margin'></hr>
              <div>
                <p className="card-text fs-md-16 fs-14 fw-400 ">This year</p>
                <p className="card-title fs-md-14 fs-12 fw-600 "> {priceTagFormatter(dashboardDetails.current_year_cash)} / {priceTagFormatter(dashboardDetails.current_year_card)} / {priceTagFormatter(dashboardDetails.current_year_upi)}</p>
                <p className="text-muted fs-10 fw-500"> Cash | Card | UPI </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4"></div>
        <div className="col-lg-4"></div>
      </div>}
    </div>
  )
}

export default Index